export class CloseCaptionReconfig {
  constructor() {
    this.config = {};
    this.ccInfo = [];
    this.videoConfig = {};
    this.videoApiData = {};
  }
  reconfiguireCcConfig(apiData, videoContainer) {
    this.videoConfig = apiData["config"];
    this.videoApiData = apiData;
    if (
      this.videoConfig["ccFileRoot"] &&
      typeof this.videoConfig["ccFileRoot"] == "string"
    ) {
      if (
        this.videoConfig["ccInfo"] &&
        typeof this.videoConfig["ccInfo"] == "object" &&
        this.videoConfig["ccInfo"].length > 0
      ) {
        $(`#${videoContainer}`).addClass("with-cc");
        return this.videoConfig;
      } else if (
        this.videoApiData["ccInfo"] &&
        Object.keys(this.videoApiData["ccInfo"]).length > 1
      ) {
        for (const key in this.videoApiData["ccInfo"]) {
          if (key.length < 12) {
            const fileName = this.videoApiData["ccInfo"][key];
            this.ccInfo.push({
              lang: key,
              file: fileName,
            });
          }
        }
        if (this.videoConfig["ccFileRoot"].split("/")[0] == "en") {
          const _rootUrl = this.videoConfig["ccFileRoot"].split("/");
          this.videoConfig["ccFileRoot"] =
            "/" + _rootUrl.slice(1, _rootUrl.length).join("/");
        }
        this.config = this.videoConfig;
        this.config["ccInfo"] = this.ccInfo;
        $(`#${videoContainer}`).addClass("with-cc");
        return this.config;
      }
    }
    return this.videoConfig;
  }
}
